import { indexTree } from "app/pages/sales-intelligence/utils/taxonomy-tree/tree";

import type { IndustryTaxonomyDto, IndustryTaxonomyIndex } from "../types/taxonomy";

/**
 * Binds the generic tree algebra to the industry taxonomy. The algebra itself is a data structure
 * (`utils/taxonomy-tree`), reusable by any taxonomy that adopts opaque node ids.
 */
export const indexTaxonomy = (dto: IndustryTaxonomyDto): IndustryTaxonomyIndex => indexTree(dto.industries);

export {
    canonicaliseValues,
    collectAncestorsOfChecked,
    flattenVisibleRows,
    impliedLeafIds,
    revealAncestors,
    toggleNode,
} from "app/pages/sales-intelligence/utils/taxonomy-tree/tree";
